import { render } from "./NotificationPanel.vue?vue&type=template&id=4bc4b884&scoped=true"
import script from "./NotificationPanel.vue?vue&type=script&lang=js"
export * from "./NotificationPanel.vue?vue&type=script&lang=js"

import "./NotificationPanel.vue?vue&type=style&index=0&id=4bc4b884&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bc4b884"]])

export default __exports__